import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductFilterContainerFilters } from "../../api/requests/interfaces/Product";
import { useAppDispatch, useAppSelector } from "../hooks";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { AppDispatch } from "../store";

interface SearchState {
    searchQuery: string; // State variable for search input
    filters: ProductFilterContainerFilters;
    filtersInitialized: boolean;
    searchFromFilterBtn: boolean;
    queryString: string;
}

export const DEFAULT_PRODUCTS_PAGE = 0;
export const DEFAULT_PRODUCTS_TAKE = 20;

const initialState: SearchState = {
    searchQuery: "",
    filters: {
        startPrice: undefined,
        endPrice: undefined,
        title: undefined,
        description: undefined,
        location: undefined,
        startDate: undefined,
        endDate: undefined,
        startTime: undefined,
        endTime: undefined,
        oneDayRentalDate: undefined,
        isOneDayRental: undefined,
        category: undefined,
        page: DEFAULT_PRODUCTS_PAGE,
        take: DEFAULT_PRODUCTS_TAKE
    },
    filtersInitialized: false,
    searchFromFilterBtn: false,
    queryString: ""
};

export const searchSlice = createSlice({
    name: "search",
    initialState,
    reducers: {
        setSearchQuery: (state, action: PayloadAction<string>) => {
            state.searchQuery = action.payload; // Update the search query
        },
        setFiltersInitialized: (state) => {
            state.filtersInitialized = true;
        },
        setSearchFromFilterBtn: (state, action: PayloadAction<boolean>) => {
            state.searchFromFilterBtn = action.payload;
        },
        updateFilterValues: (state, action: PayloadAction<ProductFilterContainerFilters>) => {
            state.filters = action.payload
        },
        updateQueryString: (state, action: PayloadAction<string>) => {
            state.queryString = action.payload;
        },
        removeAllFilters: (state) => {
            state.filters = { ...initialState.filters };
            state.searchQuery = "";
        },
    },
});

export const useHandleSearch = () => {

    const searchQuery = useAppSelector((s) => (s as any).search.searchQuery);
    const prevQueryString = useAppSelector((s) => (s as any).search.queryString);
    const searchFromSearchBtn = useAppSelector((s) => (s as any).searchFromFilterBtn);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    // Function to generate the query string from filters
    const getQueryString = (filters: ProductFilterContainerFilters) => {
        let url = "?q=" + encodeURIComponent(searchQuery) + "&";

        const queryFilters = Object.entries(filters)
            .filter(([key, value]) => value !== undefined && value !== null)
            .map(([key, value]) => {
                if (Array.isArray(value)) {
                    return value
                        .map((item) => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`)
                        .join("&");
                }
                return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            })
            .join("&");

        return url + queryFilters;
    };

    // Search handler function
    const handleSearch = (filters: ProductFilterContainerFilters, previousSearchFromFilterBtnVal: boolean, searchFromFilterBtnNew?: boolean) => {

        /* if (Object.keys(filters).length === 0) { // If no filters provided, take them from global state
            console.log("no filters provided, checking state")
            filters = globalStateFilters;
        } */
       if (previousSearchFromFilterBtnVal) {
        dispatch(setSearchFromFilterBtn(false));
        return;
       }
       if (!!searchFromFilterBtnNew) {
        console.log('set true');
        dispatch(setSearchFromFilterBtn(true));
       }
       console.log("HANDLE SEARCH ACTION", previousSearchFromFilterBtnVal);
        // if (!!initial) {
        //     dispatch(setFiltersInitialized());
        // }
        dispatch(updateFilterValues(filters)); // Update filters in Redux store
        if (filters.title) {dispatch(setSearchQuery(filters.title))};
        const queryString = getQueryString(filters);
        if (queryString != prevQueryString) {
            dispatch(updateQueryString(queryString));
            navigate("/search" + queryString);
            window.scrollTo(0, 0);
        }
    };

    return { handleSearch };
};

export const { setSearchQuery, updateFilterValues, removeAllFilters, setFiltersInitialized, updateQueryString, setSearchFromFilterBtn } = searchSlice.actions;

export default searchSlice.reducer;
